// Pages
export const HOME_PAGE_URL = '/';
export const REVIEWS_PAGE_URL = '/reviews';
export const TOUR_PAGE_URL = '/tour';
export const DOMINATION_GALLERY_PAGE_URL = '/domination-gallery';
export const ABDL_GALLERY_PAGE_URL = '/abdl-gallery';
export const HOW_TO_BOOK_PAGE_URL = '/booking/how-to-book';
export const ABOUT_PAGE_URL = '/about';
export const DOMINATION_SERVICES_PAGE_URL = '/services/domination';
export const ABDL_SERVICES_PAGE_URL = '/services/adult-baby';
export const ABDL_FORM_PAGE_URL = '/forms/adult-baby-application-form';
export const DOM_FORM_PAGE_URL = '/forms/domination-application-form';
export const LINKS_PAGE_URL = '/extra-links';
export const CONTACT_PAGE_URL = '/contact';

// Terms and Conditions
export const POLICIES_PAGE_URL = '/user-agreements';

// Maintainance
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';

// Error
export const ERROR_404_PAGE_URL = '*';

// User pages
export const LOGIN_PAGE_URL = '/login';

// Admin pages
export const ADMIN_PAGE_URL = '/admin';
export const ADMIN_CONTACT_FORM_PAGE_URL = '/admin/contact-forms';
export const ADMIN_CALLBACK_FORM_PAGE_URL = '/admin/callback-forms';
